<mat-card>
  <h2 translate>training.pills.title</h2>
  <p translate>training.pills.subtitle</p>
</mat-card>

<!-- TODO: Once Angular Material is upgraded from version 11 to 14, add the property preserveContent for caching videos and docs in the second and third tab -->
<mat-tab-group color="accent">
  <mat-tab label="{{ 'training.pills.featured' | translate | uppercase }}">
    <mat-card>
      <h2>
        {{ 'training.pills.featured' | translate | uppercase }}
      </h2>
      <mat-card-content>
        <div *ngIf="featuredList.length > 0; else featuredEmpty" class="card-featured__content">
          <scf-featured-card-item *ngFor="let featuredItem of featuredList" [data]="featuredItem">
          </scf-featured-card-item>
        </div>
        <ng-template #featuredEmpty>
          <div class="card__content--empty">
            <p translate>training.pills.featured.empty</p>
          </div>
        </ng-template>
      </mat-card-content>
    </mat-card>
  </mat-tab>

  <mat-tab label="{{ 'training.pills.documents' | translate | uppercase }}">
    <ng-template matTabContent>
      <div *ngIf="documentList.length > 0; else documentsEmpty" class="documentation-formation__container">
        <scf-formation-data-item
          *ngFor="let item of documentList"
          [element]="item"
          type="pills"
        ></scf-formation-data-item>
      </div>
      <ng-template #documentsEmpty>
        <mat-card>
          <div class="card__content--empty">
            <p translate>training.pills.documents.empty</p>
          </div>
        </mat-card>
      </ng-template>
    </ng-template>
  </mat-tab>

  <mat-tab label="{{ 'training.pills.tutorials' | translate | uppercase }}">
    <ng-template matTabContent>
      <div *ngIf="categoryList.length > 0; else categoryListEmpty" class="tutorials__container">
        <scf-pills-tutorial-categories
          *ngFor="let category of categoryList"
          [category]="category"
          [language]="language"
        >
        </scf-pills-tutorial-categories>
      </div>
      <ng-template #categoryListEmpty>
        <mat-card>
          <div class="card__content--empty">
            <p translate>training.pills.tutorials.empty</p>
          </div>
        </mat-card>
      </ng-template>
    </ng-template>
  </mat-tab>
</mat-tab-group>
